<template>
  <v-container>
    <v-tabs centered v-model="tabs" icons-and-text color="accent">
      <v-tab v-for="(tab, i) in allTabs" :key="i" :title="tab.title">
        {{ tab.title }} <v-icon>{{ tab.icon }}</v-icon>
      </v-tab>
    </v-tabs>
    <v-tabs-items v-model="tabs">
      <v-tab-item>
        <NotExported></NotExported>
      </v-tab-item>
      <v-tab-item>
        <NotExportedToPigult></NotExportedToPigult>
      </v-tab-item>
      <v-tab-item>
        <Exported></Exported>
      </v-tab-item>
      <v-tab-item>
        <RequiresAttention></RequiresAttention>
      </v-tab-item>
      <v-tab-item>
        <Undescribed></Undescribed>
      </v-tab-item>
      <v-tab-item>
        <LegacyData></LegacyData>
      </v-tab-item>
      <v-tab-item>
        <ExportHistory></ExportHistory>
      </v-tab-item>
    </v-tabs-items>
  </v-container>
</template>

<script>
import NotExported from "@/components/Listings/NotExported.vue";
import Exported from "@/components/Listings/Exported.vue";
import RequiresAttention from "@/components/Listings/RequiresAttention.vue";
import Undescribed from "@/components/Listings/Undescribed.vue";
import LegacyData from "@/components/Listings/LegacyData.vue";

import ExportHistory from "@/components/Listings/ExportHistory.vue";
import NotExportedToPigult from '../Listings/NotExportedToPigult.vue';

export default {
  name: "Supervision",
  components: {
    NotExported,
    Exported,
    RequiresAttention,
    Undescribed,
    LegacyData,
    ExportHistory,
    NotExportedToPigult,
  },
  data: () => ({
    tabs: 0,
    allTabs: [
      { title: "Not exported", icon: "mdi-file-excel" },
      { title: "Not exported to pigu.lt", icon: "mdi-file-excel" },

      { title: "Exported", icon: "mdi-file-check" },
      { title: "Requires attention", icon: "mdi-file-alert" },
      { title: "Not described", icon: "mdi-file" },
      { title: "Legacy data", icon: "mdi-file-key" },
      { title: "Export history", icon: "mdi-history" },
    ],
  }),
  methods: {},
};
</script>